import {CONSTANTS} from "../components/config/constants";
import {Users} from "../components/user/users";

const Admin = () => {
    return <Users no_users={'No System Administrators'} user_type={CONSTANTS.USER_TYPES.ADMINISTRATOR}
                  page_title={'System Administrators'}/>
}
export default Admin;
